import config from './config';

const search = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      enableSearch: true,
      enableSearchAnalytics: true,

      searchResults: { path: '/s' },

      /**
       * The configuration for the search history to be saved in the local storage.
       */
      searchHistory: {
        /**
         * The key to be used in the local storage to save the search history.
         *
         * Might be overridden by the brand config.
         *
         * **IMPORTANT**: This key should be unique across all brands to avoid conflicts.
         */
        key: 'searchHistory',
        /**
         * The maximum number of searches to be saved in the local storage.
         */
        numberOfSearches: 6
      },

      /**
       * This will be applied on the search suggestions upon searching on the search bar.
       *
       * Will be ignored if `enableSearch` is set to false.
       */
      searchSuggestions: {
        // A standard debounce time for the search suggestions.
        debounceTimeOnInput: 300,
        /**
         * A default number of products to suggest for the product suggestions.
         *
         * This doesn't mean that the API will return this number of products, but it will try to
         * suggest this number of products.
         *
         * The actual number of products returned may be less than this number, but never more.
         */
        productSuggestionsLimitOnSearch: { server: 4, desktop: 4, mobile: 4 },

        /**
         * A default number of terms to suggest for the search suggestions.
         *
         * This doesn't mean that the API will return this number of terms, but it will try to
         * suggest this number of terms.
         *
         * The actual number of terms returned may be less than this number, but never more.
         */
        termsSuggestionsLimitOnSearch: { server: 5, desktop: 5, mobile: 5 },

        /**
         * Configuration for the product suggestion tiles.
         */
        productSuggestionTile: {
          /**
           * The next/image `sizes` attribute for the product suggestion tile images.
           *
           * This is used to help next to optimize the images for different screen sizes.
           *
           * If this changes somehow by brand in it's styles, override it in the brand config,
           * but this overall should be a good default for all brands designs set
           * here on figma {@link https://www.figma.com/design/rpvXYGjPl3YKghFGHxvcxO/Internal-Search-Workshop?node-id=380-12830&m=dev} (May 30, 2025 Version).
           */
          sizes: '(max-width: 1024px) 140px, 180px'
        }
      },
      /** Whether to display rating stars or not in the product tiles. */
      displayRatings: false,
      /**
       * Whether to display the search all link in the product suggestions.
       */
      showSearchAllLink: true,
      /**
       * Configuration for the AB suggested terms personalization experience.
       */
      ABSuggestedTerms: {
        /** Whether the AB suggested terms experience is enabled. */
        enabled: false
      }
    }
  },
  'AHNU-US': { default: { enableSearch: false } },
  'TEVA-US': {
    default: {
      searchHistory: {
        /**
         * Right now we are using the same used in TEVA's search history to support the backport
         * once we migrate to DECA.
         *
         * See {@link https://deckersbrand.atlassian.net/browse/HP-4785}.
         */
        key: 'deckers_recentSearches'
      },
      displayRatings: true,
      showSearchAllLink: false,
      ABSuggestedTerms: { enabled: true }
    }
  }
});

export default search;
